export const ADD_QUOTATION = 'quotation/FETCH';
export const ADD_QUOTATION_SUCCESS = `${ADD_QUOTATION}_SUCCESS`;
export const ADD_QUOTATION_FAIL = `${ADD_QUOTATION}_FAIL`;
export const ADD_QUOTATION_RESET = `${ADD_QUOTATION}_RESET`;

const initialState = {
  isLoading: false,
  isLoaded: false,
  error: null,
  isError: false
};

export const QuotationReducer = (state = initialState, action = {}) => {

  switch (action.type) {
    case ADD_QUOTATION_RESET:
      return initialState;
    case ADD_QUOTATION:
      return { ...state, isLoading: true, isError: false };
    case ADD_QUOTATION_SUCCESS:
      return {
        ...state,
        idQuotation: action.payload.data.id,
        isLoading: false,
        isLoaded: true,
        isError: false
      };
    case ADD_QUOTATION_FAIL:
      return {
        ...state,
        isLoaded: false,
        isLoading: false,
        error: action.error,
        isError: true
      };

    default: return state;
  }
};
